/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CancelScheduledLaunchMutationResponse,
  CancelScheduledLaunchPathParams,
} from '../types/CancelScheduledLaunch'

function getCancelScheduledLaunchUrl({
  bison_campaign_id,
}: {
  bison_campaign_id: CancelScheduledLaunchPathParams['bison_campaign_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/emailbison/campaigns/${bison_campaign_id}/cancel-scheduled-launch/` as const,
  }
  return res
}

/**
 * @description Clear scheduled_launch_at and move the campaign back to READY_TO_LAUNCH.
 * @summary Cancel a scheduled campaign launch
 * {@link /api/v1/emailbison/campaigns/:bison_campaign_id/cancel-scheduled-launch/}
 */
export async function cancelScheduledLaunch(
  {
    bison_campaign_id,
  }: {
    bison_campaign_id: CancelScheduledLaunchPathParams['bison_campaign_id']
  },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    CancelScheduledLaunchMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'POST',
    url: getCancelScheduledLaunchUrl({ bison_campaign_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
